import React from 'react';
import { Text } from '@perch-labs/shrike';
import { Container, Page } from 'styles';

export const MaintenancePage = () => (
  <Page margin="auto" data-testid="maintenance-page">
    <Container
      flex
      direction="column"
      alignItems="center"
      margin="76px auto"
      maxWidth="448px"
    >
      <Text
        tag="h1"
        textStyle="heading800"
        margin="44px 0 8px"
        textAlign="center"
      >
        We&rsquo;re down for scheduled maintenance.
      </Text>
      <Text
        tag="p"
        textStyle="paragraph400"
        textAlign="center"
        margin="24px 0 0"
      >
        Our service is temporarily unavailable. Please check back soon.
      </Text>
    </Container>
  </Page>
);
